var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.row
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.discount')))]), _c('span', [_vm._v(_vm._s(_vm.formattedDiscountAmount))])]), _c('div', {
    class: _vm.$style.row
  }, [_c('span', [_vm._v(_vm._s(_vm.promoCode))]), _c('span', [_vm._v(_vm._s(_vm.formattedDiscountValue))])]), _c('div', {
    class: _vm.$style.row
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.total')))]), _c('span', [_vm._v(_vm._s(_vm.formattedTotalAmount))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }